import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Overview = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Dashboard/Overview.vue')
const Reports = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Dashboard/Reports.vue')
const Settings__POS = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Settings/POS.vue')
const Settings__AutomaticProcesses = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Settings/AutomaticProcesses.vue')
const Widgets = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Dashboard/Widgets.vue')
// Memberships Pages
const customersMemberships__Memberships = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/Memberships.vue')
const customersMemberships__MMU = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/MembershipsAdm.vue')
const customersMemberships__Customers = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/Customers.vue')
// Plans Pages
const plans__Viewer = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Plans.vue')
const plans__ShiftsNFamilies = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Shifts&Families.vue')
const plans__Creator = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Creator.vue')
const aiLogin = () => import(/* webpackChunkName: "aiLogin" */ '../components/Dashboard/Views/ai-login/App.vue')
// Pages
import User from '../components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from '../components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from '../components/Dashboard/Views/Pages/Login.vue'
import SuccessfullPayment from '../components/Dashboard/Views/Pages/SuccessfullPayment.vue'
import Register from '../components/Dashboard/Views/Pages/Register.vue'
import Lock from '../components/Dashboard/Views/Pages/Lock.vue'
import DailyPassValidator from '../components/Dashboard/Views/Pages/DailyPassValidator.vue'
import Logout from '../components/Dashboard/Views/Pages/Logout.vue'

// Components pages
import Buttons from '../components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from '../components/Dashboard/Views/Components/GridSystem.vue'
import Panels from '../components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from '../components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from '../components/Dashboard/Views/Components/Notifications.vue'
import Icons from '../components/Dashboard/Views/Components/Icons.vue'
import Typography from '../components/Dashboard/Views/Components/Typography.vue'
import UnderConstruction from '../components/Dashboard/Views/UnderConstruction/underConstruction.vue'

// Forms pages
const RegularForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/VectorMapsPage.vue');

// customers
// import customersMain from '../components/Dashboard/Views/Customers/CustomersMain.vue'

// Calendar
import Calendar from '../components/Dashboard/Views/Calendar/CalendarRoute.vue'
import { path } from 'd3'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ '../components/Dashboard/Views/Charts.vue')

// Downloads
const Downloads = () => import(/* webpackChunkName: "downloads" */ '../components/Dashboard/Views/Downloads/Downloads.vue')

let downloadsMenu = {
  path: '/downloads',
  name: 'Downloads',
  redirect: '/downloads/win',
  component: DashboardLayout,
  children: [
    {
      path: '/downloads/win',
      name: 'downloadsWin',
      component: Downloads
    },
  ]
}

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ],
  meta: { requiresAuth: true, requiresSupport: true }
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }],
  meta: { requiresAuth: true, requiresSupport: true }
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    // {
    //   path: 'user',
    //   name: 'User Page',
    //   component: User
    // },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}
let SuccessfullPaymentPage = {
  path: '/successfull-payment',
  name: 'SuccessfullPayment',
  component: SuccessfullPayment
}
let userProfile = {
  path: '/User',
  name: 'User',
  component: User
}
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}
let logoutPage = {
  path: '/logout',
  name: 'Logout',
  component: Logout
}
let plansPage = {
  path: '/plans',
  component: DashboardLayout,
  redirect: '/plans/overview',
  children: [
    {
      path: 'create',
      name: 'Create',
      component: plans__Creator
      // component: UnderConstruction
    },
    {
      path: 'plansviewer',
      name: 'PlansViewer',
      component: plans__Viewer
      // component: UnderConstruction
    },
    {
      path: 'shifts&families',
      name: 'Shifts&Families',
      component: plans__ShiftsNFamilies
      // component: UnderConstruction
    },
  ]
}
let salesPage = {
  path: '/sales',
  component: DashboardLayout,
  redirect: '/sales/overview',
  children: [
    {
      path: 'overview',
      name: 'SalesMain',
      component: UnderConstruction
    }
  ]
}
let customersMembershipsPage = {
  path: '/customers&memberships',
  component: DashboardLayout,
  redirect: '/customers&memberships/customers',
  children: [
    {
      path: 'customers',
      name: 'Customers',
      component: customersMemberships__Customers
      // component: process.env.VUE_APP_BUILD_MODE === "2" ? UnderConstruction : customersMemberships__Customers
    },
    {
      path: 'memberships',
      name: 'MembershipsMain',
      component: customersMemberships__Memberships
    },
    {
      path: 'MMU',
      name: 'MMU',
      // component: UnderConstruction
      component: customersMemberships__MMU
    },
  ]
}
let settingsPage = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/POS',
  children: [
    {
      path: 'POS',
      name: 'Points of sales',
      component: Settings__POS
    },
    {
      path: 'AP',
      name: 'AccessPoints',
      component: UnderConstruction
    },
    {
      path: 'AutomaticProcesses',
      name: 'AutomaticProcesses',
      component: Settings__AutomaticProcesses
    },
  ]
}
let aiLoginPage = {
  path: '/ai-login',
  name: 'ai-login',
  component: aiLogin,
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      }
    ],
    meta: { requiresAuth: true, requiresSupport: false }
  },
  componentsMenu,
  downloadsMenu,
  plansPage,
  salesPage,
  settingsPage,
  customersMembershipsPage,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  registerPage,
  SuccessfullPaymentPage,
  lockPage,
  logoutPage,
  userProfile,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports
        // component: UnderConstruction
      },
      {
        path: 'User',
        name: 'User',
        component: User
        // component: UnderConstruction
      },
      {
        path: 'configs',
        name: 'Configuraciones',
        component: UnderConstruction
      },
      {
        path: 'memberships',
        name: 'Socios',
        component: UnderConstruction
      },
      {
        path: 'entries',
        name: 'Accesos',
        component: UnderConstruction
      },
      {
        path: 'sales',
        name: 'Sales',
        component: UnderConstruction
      }
    ],
    meta: { requiresAuth: true, requiresSupport: false }
  },
  aiLoginPage,
  { path: '/dailyPassValidator', component: DailyPassValidator },
  { path: '*', component: NotFound }
];

export default routes
